import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';

const ContactPage = () => {
    const contactData = {
        name: 'Prince Kumar',
        mobile: '+91 98765 43210',
        // Updated address
        address: 'AARADHYA LIBRARY, Shiv Mandir Rd, Lohiyanagar, Lohianagar, Begusarai, Bihar 851218' 
    };

    // Encodes the new address for a Google Maps URL
    const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactData.address)}`;

    return (
        <Container className="my-5">
            <h2 className="text-center mb-4">Contact Us</h2>
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="p-4 shadow-sm">
                        <Card.Body>
                            <h3 className="mb-3">Our Team</h3>
                            <div className="contact-details">
                                <h5>{contactData.name}</h5>
                                <p><strong>Mobile:</strong> {contactData.mobile}</p>
                                <p>
                                    <strong>Address:</strong>
                                    <br />
                                    <a 
                                        href={googleMapsLink} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        {contactData.address}
                                    </a>
                                </p>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ContactPage;